const { getElement } = window.BAO.Utils

class RiseForm extends window.BAO.CustomElement() {
  async connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.form.element,
      'submit',
      this.onSubmitHandler.bind(this),
    )

    if (this.els.datepicker_show) {
      this.listeners.add(
        this.els.datepicker_show?.element,
        'click',
        this.datepickerShow.bind(this),
      )
    }

    if (this.els.datepicker_hide) {
      this.listeners.add(
        this.els.datepicker_hide.element,
        'click',
        this.datepickerHide.bind(this),
      )
    }

    this.els.input?.elements.forEach(input => {
      input.addEventListener('change', this.onInputChange.bind(this))
    })

    if (this.els.send_at) {
      this.els.send_at.element.addEventListener(
        'change',
        this.onSendAtChange.bind(this),
      )
    }
  }

  onSendAtChange () {
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ]

    this.els.datepicker.element.setAttribute('aria-hidden', 'true')

    const date = new Date(this.els.send_at.element.value)
    this.els.datepicker_choose.element.setAttribute('aria-hidden', true)
    this.els.datepicker_choosen.element.setAttribute('aria-hidden', false)
    this.els.datepicker_date.element.innerText = `: ${
      months[date.getMonth()]
    } ${date.getDate()} ${date.getFullYear()}`

    this.els.form_toggle?.elements.forEach(toggle => {
      toggle.setAttribute('aria-hidden', 'false')
    })
    this.externalEls.form_toggle?.elements.forEach(toggle => {
      toggle.setAttribute('aria-hidden', 'false')
    })
  }

  datepickerShow () {
    this.els.datepicker_hide?.element.classList.remove(
      'mod-Rise_FormDate-active',
    )
    this.els.datepicker_show?.element.classList.add('mod-Rise_FormDate-active')
    this.els.datepicker?.element.setAttribute('aria-hidden', 'false')

    this.els.form_toggle?.elements.forEach(toggle => {
      toggle.setAttribute('aria-hidden', 'true')
    })
    this.externalEls.form_toggle?.elements.forEach(toggle => {
      toggle.setAttribute('aria-hidden', 'true')
    })
  }

  datepickerHide () {
    this.els.datepicker_show?.element.classList.remove(
      'mod-Rise_FormDate-active',
    )
    this.els.datepicker_hide?.element.classList.add('mod-Rise_FormDate-active')
    this.els.datepicker?.element.setAttribute('aria-hidden', 'true')

    this.els.form_toggle?.elements.forEach(toggle => {
      toggle.setAttribute('aria-hidden', 'false')
    })
    this.externalEls.form_toggle?.elements.forEach(toggle => {
      toggle.setAttribute('aria-hidden', 'false')
    })

    this.els.send_at.element.value = new Date().toISOString()
  }

  async onSubmitHandler (event) {
    event.preventDefault()

    const email = getElement('[name="properties[_recipient_email]"]', {
      context: this,
    })
    const sendAt = this.els.send_at

    const gift = {
      gift: {
        name: getElement('[name="properties[_recipient_name]"]', {
          context: this,
        }).value,
        message: getElement('[name="properties[_gift_message]"]', {
          context: this,
        }).value,
        image: this.els.gift_image?.element?.value,
        variant_id: this.els.id?.element?.value,
      },
    }

    if (email) {
      gift.gift.email = email.value
    }

    if (sendAt) {
      gift.gift.send_at =
        sendAt.element.value.length > 0 ? sendAt.element.value : null
    }

    this.addToCart()
    this.closest('rise-modal').hideModal()
  }

  async addToCart () {
    return window.BAO.Cart.addItemFromForm(this.els.form.element)
  }

  onInputChange () {
    const canSubmit = this.canSubmitCheck()

    if (!canSubmit) {
      this.showButton()
    } else {
      this.removeButton()
    }
  }

  canSubmitCheck () {
    const canSubmit = this.els.input?.elements.find(input => {
      return input.value.length === 0
    })

    return canSubmit
  }

  showButton () {
    this.els.submit.element.classList.add('btn-Button-primary')
    this.els.submit.element.classList.remove('btn-Button-inactive')
    this.els.submit.element.removeAttribute('disabled')
  }

  removeButton () {
    this.els.submit.element.classList.remove('btn-Button-primary')
    this.els.submit.element.classList.add('btn-Button-inactive')
    this.els.submit.element.setAttribute('disabled', true)
  }
}

if (!customElements.get('rise-form')) {
  customElements.define('rise-form', RiseForm)
}
